var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 579,
    height: 506,
    viewBox: "0 0 579 506",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M234.306 -115.63C247.545 -133.66 275.148 -131.382 285.252 -111.426L575.325 461.46C585.923 482.392 569.475 506.84 546.093 504.911L-124.037 449.612C-147.419 447.683 -159.637 420.869 -145.751 401.958L234.306 -115.63Z",
    fill: "#42c485"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle2);
export default __webpack_public_path__ + "static/media/triangle2.694359a0634f1bfb89bae7704ea9cfe2.svg";
export { ForwardRef as ReactComponent };